import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import { UserPlus } from "lucide-react";

import ClientReferralForm from "./ClientReferralForm";

const ClientReferral = () => {

  return (
    <HeaderComponent
      title="Refer a Client"
      description="Help another business grow with Hyvid"
      cardBorder="white-emerald"
      icon={<UserPlus className="w-5 h-5"/>}
      colorTheme="flat-emerald"
    >
      <ClientReferralForm/>
    </HeaderComponent>
  );
};

export default ClientReferral;
